module.exports = {
  jsConfig: 'wx/js_config',                       // 微信jssdk配置获取
  cardConfig: 'wx/card_config',                   // 微信html发券jssdk配置获取
  getSubsidy: 'subsidy/get_subsidy',              // 随机补贴金获取
  listInfo: 'subsidy/list_info',                  // 津贴商品列表
  goodsUrl: 'subsidy/goods_url',                  // 生成商品购买链接
  userOauth: 'wx/user_oauth',                     // 微信用户授权
  getCardMoney: 'subsidy/get_card_money',         // 津贴卡领取
  userOauth: 'wx/user_oauth',
  cardInfo: 'subsidy/card_info',                  // 用户津贴信息获取
  channelRec: 'v2/channel_record',                  // 渠道落地页统计
}